<!-- //
数据服务-接口配置详情
@auth xuyd
@date 2024-05-05
//-->
<template>
  <page-layout layout="C">
    <div class="layout-function flex-row flex-valign-center flex-halign-between">
      <div class="flex-row flex-valign-center">
        <span class="title">{{ form.apiName }}</span>
        <el-divider direction="vertical"/>
        <Version v-model="form.apiVersion" class="mr10"/>
        <span class="info">{{ form.apiComment }}</span>
      </div>
      <div class="flex-row flex-valign-center">
        <el-button size="small" type="primary" @click="handleSave" :loading="loading">保 存</el-button>
        <el-button size="small" @click="handleCancel">返 回</el-button>
      </div>
    </div>

    <div class="layout-result" style="height: 100%;margin-top: 5px;overflow-y: auto;">
      <el-backtop :bottom="100" :visibility-height="0">UP</el-backtop>
      <el-form @submit.native.prevent ref="refForm"
               :model="form"
               :rules="rules"
               size="small"
               label-position="top"
               class="form-container"
               style="flex: 1;">
        <el-row :gutter="20" style="height: 100%; margin: 0; padding: 0">
          <el-col :span="14" class="flex-column" style="height: 100%; padding: 0">
            <el-row class="flex-row">
              <el-form-item prop="dsName" label="">
                <div class="flex-row">
                  <el-select
                      v-model="form.dsName"
                      placeholder="请选择数据源"
                      clearable
                      style="width: 300px">
                    <el-option
                        v-for="item in this.databaseList"
                        :key="item.text"
                        :label="item.text"
                        :value="item.text"
                    />
                  </el-select>
                  <div class="flex-row flex-halign-between ml10">
                    <el-button size="small" type="danger" @click="handleExecute" :loading="testLoading">测 试</el-button>
                  </div>
                </div>
              </el-form-item>
              <el-form-item prop="cacheable" label="" class="ml20">
                <div class="flex-row flex-valign-center">
                  <span>是否缓存</span>
                  <el-switch class="ml10" v-model="form.cacheable" :active-value="1" :inactive-value="0"/>
                </div>
              </el-form-item>
              <el-form-item prop="cacheTime" label="" class="ml20">
                <div class="flex-row flex-valign-center">
                  <span>缓存时长</span>
                  <el-input class="ml10" style="width: 80px"
                            v-model="form.cacheTime"
                            maxlength="5"
                            :disabled="form.cacheable !== 1"
                            @input="() => {form.cacheTime = form.cacheTime.replace(/[^0-9]/g, '')}"/>
                  <span class="ml5">单位：秒</span>
                </div>
              </el-form-item>
            </el-row>
            <el-form-item prop="script" class="full-item_2">
              <!--              <div slot="label" class="item-label">-->
              <!--                <span class="label">配置脚本</span>-->
              <!--              </div>-->
              <MonacoEditor v-model="form.script" :options="scriptOptions" style="height: 600px;" @change="$refs.refForm.validateField('script')"/>
            </el-form-item>

            <!-- 请求参数 -->
            <el-form-item prop="reqParamList" v-show="form.reqParamList && form.reqParamList.length > 0" class="full-item">
              <div slot="label" class="item-label flex-row flex-valign-center">
                <span class="label">请求参数</span>
                <el-radio-group v-model="activeReqIndex">
                  <el-radio-button label="one">可视化编辑模式</el-radio-button>
                  <el-radio-button label="two">代码编辑模式</el-radio-button>
                </el-radio-group>
              </div>
              <!-- 请求参数：表格 -->
              <ApiQueryParams v-model="form.reqParamList"
                              v-show="activeReqIndex === 'one'"
                              :edit-mode="false"
                              :config-mode="true"
                              @change="mergeTableToJson"
                              style="height: auto; max-height: 200px; overflow-y: auto;"/>
              <!-- 请求参数：JSON -->
              <div v-show="activeReqIndex === 'two'" style="height: 200px; max-height: 200px;">
                <MonacoEditor v-model="form.reqParams" :options="reqParamsOptions" />
              </div>
            </el-form-item>

          </el-col>
          <el-col :span="10" class="flex-column" style="padding: 0 0 0 10px; height: 100%">
            <el-tabs tab-position="top" style="padding:0;" class="full-item_2">
              <el-tab-pane label="响应结果">
                <MonacoEditor v-model="form.respResult" :options="resultOptions" style="height: 600px;" />
              </el-tab-pane>
              <el-tab-pane label="执行SQL">
                <MonacoEditor v-model="form.querySql" :options="querySqlOptions"  style="height: 600px;"/>
              </el-tab-pane>
            </el-tabs>

            <!-- 返回参数 -->
            <el-form-item prop="respParamList">
              <div slot="label" class="item-label"><span class="label">返回参数</span></div>
              <ApiQueryParams v-model="form.respParamList"
                              style="max-height: 343px; overflow-y: auto;"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </page-layout>
</template>

<script>

import ApiDesignApi from '@/api/datasvc/apiDesign.api.js';
import ApiQueryParams from '@/components/Table/FormTable.vue'
import DatasourceApi from "@/api/datasvc/datasource.api";
import MonacoEditor from '@/components/Editor/monacoEditor.vue'

export default {
  name: 'ViewApiDesignConfig',
  components: {ApiQueryParams, MonacoEditor},
  dictTypes: [
    {dictType: 'DB_TYPE', dataType: String},
  ],
  data() {
    return {
      databaseList: [],
      loading: false,
      saveLoading: false,
      testLoading: false,
      watcher_is_init: true, // 判断页面是否变化，首次设置区分
      watcher_is_changed: false,// 判断页面是否变化
      activeReqIndex: 'one',
      scriptOptions: {languageGroup: 'sql', language: 'pgsql'},
      reqParamsOptions: {language: 'json', autoFormat: true,},
      resultOptions: {language: 'json', autoFormat: true,}, // readOnly: true
      querySqlOptions: {languageGroup: 'sql', language: 'pgsql', readOnly: true},
      form: {
        id: null,
        apiId: null,
        apiName: null, // 唯一值
        apiComment: null,
        apiVersion: null,
        dsName: null,
        cacheable: null,// 是否缓存
        cacheTime: null,// 缓存时长
        script: null,
        reqParamList: [], // 请求参数，table格式
        respParamList: [],
        reqParams: null, // 请求参数，json 字符串格式
        respResult: null, // json 字符串
        querySql: null, // 执行的sql
      },
      rules: {
        dsName: [{required: true, message: "请选择数据源", trigger: 'change'}],
        script: [{required: true, message: "请配置脚本", trigger: 'change'}],
      },
    }
  },
  computed: {
    // scriptOptions() {
    //   return {languageGroup: 'sql', language: 'pgsql', value: this.form.script};
    // },
    // reqParamsOptions() {
    //   return {language: 'json', autoFormat: true, value: this.form.reqParams};
    // },
    // sqlOptions() {
    //   return {language: 'json', autoFormat: true, readOnly: true, value: this.form.script};
    // },
  },
  watch: {
    'form.reqParams': {
      handler(newVal) {
        this.mergeJsonToTable();
      },
      deep: true,
    },
    form: {
      handler(newVal, oldVal) {
        console.log("-----form 变化前-----", this.watcher_is_init, this.watcher_is_changed)
        if(this.watcher_is_init) {
          this.watcher_is_init = false;
        } else {
          this.watcher_is_changed = true;
        }
        console.log("-----form 变化后-----", this.watcher_is_init, this.watcher_is_changed)
      },
      deep: true,
    }
  },
  created() {
    this.form.apiId = this.$route.query.id;
    this.init();
    this.getApiInfo();
  },
  methods: {
    setWatchChange(init, val) {
      this.watcher_is_init = init;
      this.watcher_is_changed = val;
    },
    init() {
      DatasourceApi.selectList().then(resp => {
        this.databaseList = resp.data;
      })
    },
    getApiInfo() {
      ApiDesignApi.getScriptConfig(this.form.apiId).then(resp => {
        this.setWatchChange(true, false);
        this.form = JSON.parse(JSON.stringify(resp.data));
      });
    },

    // merge json to table
    mergeJsonToTable() {
      if (this.form.reqParamList) {
        let json = JSON.parse(this.form.reqParams);
        this.form.reqParamList.forEach(item => {
          item.paramValue = json[item.paramName];
        });
      }
      this.form.reqParamList = JSON.parse(JSON.stringify(this.form.reqParamList));
    },

    // merge table to json
    mergeTableToJson(records) {
      if (records) {
        let json = {}
        records.forEach(item => {
          json[item.paramName] = item.paramValue;
        });
        this.form.reqParams = JSON.stringify(json);
      }
    },

    handleSave() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          let params = {...this.form};
          console.log("=======handleSave======>", params)
          ApiDesignApi.saveScript(params).then(resp => {
            this.setWatchChange(true, false);
            this.form.id = resp.data;
            this.$modal.msgSuccess("保存成功");
          });
        }
      })
    },

    /**
     * 测试
     * @param row
     */
    handleExecute(row) {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.testLoading = true;
          let params = {...this.form};
          return ApiDesignApi.execute(params).then(resp => {
            this.$modal.msgSuccess('测试完成');
            // console.log("=======handleExecute==========", resp);
            this.form.respResult = JSON.stringify(resp.data.respResult);
            this.form.querySql = resp.data.querySql;
            this.testLoading = false;
          }).catch(() => {
            this.testLoading = false;
          });
        }
      })
    },

    handleCancel() {
      if(this.watcher_is_changed) {
        this.$modal.confirm(`数据有变化，确定要放弃保存吗？`).then(() => {
          this.$router.back();
        })
      } else {
        this.$router.back();
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/css/variables.less';

.title {
  font-size: 18px;
  font-weight: 600;
}

.info {
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  margin-left: 10px;
}

.form-container {
  height: auto;
  padding-bottom: 50px;

  :deep(.el-form-item__label) {
    width: 100%;
    padding: 0;
    display: flex;
    background-color: @headerBgColor;
    border-bottom: 1px solid @headerBorderColor;
  }

  :deep(.el-tabs__header) {
    margin: 0 0 10px 0;
  }

  .item-label {
    width: 100%;

    .label {
      font-size: 14px;
      font-weight: 600;
      padding: 0 5px;
    }
  }

  .full-item {
    max-height: 500px;
  }

  //.full-item_2 {
  //  height: 650px;
  //}

  .full-item_2,
  .full-item {

    //:deep(.el-form-item__content) {
    //  height: calc(100% - 20px);
    //}

    :deep(.el-tabs__content) {
      height: 100%;
    }

    :deep(.el-tab-pane) {
      height: 100%;
    }
  }

}
</style>
